module.exports = __webpack_public_path__ + "img/1-1P61ZS14Q44.c92fc737.png";